document.addEventListener('DOMContentLoaded', () => {
  const swiperEl = document.querySelector('.js-numbers-swiper');
  if (!swiperEl) return;

  new Swiper('.js-numbers-swiper', {
    loop: false,
    autoplay: false,
    speed: 400,
    slidesPerView: '4.6',
    spaceBetween: 32,

    navigation: {
      prevEl: '.js-numbers-swiper-prev',
      nextEl: '.js-numbers-swiper-next',
    },

    breakpoints: {
      0: {
        slidesPerView: 2.1,
        spaceBetween: 8,
      },
      1021: {
        slidesPerView: 4.6,
        spaceBetween: 32,
      },
    },
  });
});
